<template>
  <div>
    <b-card>
      <div class="text-right mb-3">
        <router-link class="btn btn-primary" :to="{ name: 'bestof.create' }"
          ><i class="fa fa-plus"></i> Criar</router-link
        >
        <exporter grid-ref="campaignsGeneralGrid" :url="'campaignsgeneral/exportgeneralcampaigns'"></exporter>
      </div>
      <Grid
        ref="campaignsGeneralGrid"
        name="bestofGrid"
        v-bind:url="url"
        v-bind:preload="preload"
        v-bind:columns="columns"
        :pageable="true"
        :filterable="true"
        :sortable="true"
        v-bind:schemaModelFields="schemaModelFields"
        :default-filter="defaultFilter"
      ></Grid>
    </b-card>
  </div>
</template>

<script>
import Grid from "@/components/Grid.vue";
import router from "@/router";
import lists from "@/components/States.js";

export default {
  name: "bestofGrid",
  components: {
    Grid,
  },
  data() {
    return {
      schemaModelFields: {
        created_at: {
          type: "date",
        },
        updated_at: {
          type: "date",
        },
        state: {
          type: "number",
        },
        ym_start: {
          type: "number",
        },
        ym_end: {
          type: "number",
        },
      },defaultFilter: {
      logic: 'and',
      filters: [
        {
          field: 'state',
          operator: 'eq',
          value: 1
        }
      ]
    },
      preload: [
        {
          field: "prodaggreg_id",
          api: "prodaggregs/lst",
        },
      ],
      url: "bestof/campaigns",
      columns: [
        {
          template: this.getBtnTemplate,
          title: "",
          width: "100px",
        },
        {
          field: "id",
          title: "Id",
          width: "80px",
        },
        {
          field: "name",
          title: "Nome",
          width: "220px",
        },
        {
          field: "state",
          title: "Estado",
          values: lists.campaigns,
          width: "120px",
        },
        {
          field: "ym_start",
          title: "Inicio",
          width: "120px",
        },
        {
          field: "ym_end",
          title: "Fim",
          width: "120px",
        },
        {
          field: "enable_value",
          title: "Valor",
          values: lists.campaigns,
          width: "120px",
        },
        {
          field: "enable_operators",
          title: "Operadores",
          values: lists.campaigns,
          width: "120px",
        },
        {
          field: "enable_quantity",
          title: "Quantidade",
          values: lists.campaigns,
          width: "120px",
        },
        {
          field: "created_at",
          title: "Criado em",
          format: "{0:dd/MM/yyyy HH:mm}",
          type: "date",
          width: "180px",
          filterable: {
            // ui: "datetimepicker"
            ui: function (element) {
              element.kendoDateTimePicker({
                format: "dd/MM/yyyy HH:mm",
              });
            },
          },
        },
        {
          field: "updated_at",
          title: "Atualizado em",
          format: "{0:dd/MM/yyyy HH:mm}",
          type: "date",
          width: "180px",
          filterable: {
            // ui: "datetimepicker"
            ui: function (element) {
              element.kendoDateTimePicker({
                format: "dd/MM/yyyy HH:mm",
              });
            },
          },
        },
      ],
    };
  },
  methods: {
    getBtnTemplate: function (item) {
      var route = router.resolve({
        name: "bestof.edit",
        params: {
          id: item.id,
        },
      });
      if (this.$auth.check("bestof.edit")) {
        return (
          '<a href="' +
          route.href +
          '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
        );
      }
      return "";
    },
    exportGrid() {
      this.exporting = true;
      const grid = this.$refs.campaignsGeneralGrid.$refs.mygrid.kendoWidget();
      const filters = grid.getOptions().dataSource.filter;

      this.axios
        .post("campaignsgeneral/exportgeneralcampaigns", { filter: filters })
        .then((response) => {
          if (response.data && response.data.url) {
            window.open(response.data.url, "_blank");
          } else {
            this.$bvToast.toast("Falha ao gerar o arquivo.", {
              variant: "danger",
              solid: true,
            });
          }
          this.exporting = false;
        })
        .catch((error) => {
          console.error(error);
          this.$bvToast.toast("Houve um erro ao exportar", {
            autoHideDelay: 5000,
            variant: "danger",
            solid: true,
          });
          this.exporting = false;
        });
    },
  },
};
</script>
